import { render } from "./VARefractionCard.vue?vue&type=template&id=bab741dc&ts=true"
import script from "./VARefractionCard.vue?vue&type=script&lang=ts"
export * from "./VARefractionCard.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__